export default class DtoMaterielState {
    constructor(obj) {
        this.field = obj.field
        this.code = obj.code
        this.label = obj.label
    }
}
